import React from "react";
import { CircleArrow as ScrollUpButton } from "react-scroll-up-button";

export default function GoUp() {
  return (
    <div className="Go">
      <ScrollUpButton style={{ width: 50, zIndex: 4, marginBottom: 30 }} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/GoUp.js